import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Separator from '../../../../core/layout/Separator';
import Tags from '../../../../core/form/Tags';

const SlicesInput = props => (
  <Row>
    <Column size={12}>
      {props.slices.length > 0 && (
        <div>
          <Tags
            label={props.label}
            errorText={props.errorText}
            disabled={props.disabled}
            onDelete={props.onRemoveSlice}
            onClick={props.onShowSlice}
            onLink={props.onLinkSlice}
            color={props.color}
            tags={props.slices.map((sliceText, index) => {
              const tag = {
                index,
                text: sliceText,
                icon: null,
                canDelete: false,
                canRollback: false,
                canLink: false,
                isLinked: false,
              };
              const previousRemovedSlice = props.removedSlices.find(slice => index === slice.index - 1);
              const currentRemovedSlice = props.removedSlices.find(slice => index === slice.index);
              const nextRemovedSlice = props.removedSlices.find(slice => index === slice.index + 1);
              const sliceLinkedToNext = props.removedSlices.find(slice => slice.linkTo === index + 1);

              if (!currentRemovedSlice) {
                if (
                  (!props.disableRemove && !props.sequenceRemove) ||
                  (!props.disableRemove &&
                    props.sequenceRemove &&
                    (!props.removedSlices.length || previousRemovedSlice || nextRemovedSlice))
                ) {
                  tag.canDelete = true;
                }
                if (props.allowLink && !sliceLinkedToNext && previousRemovedSlice) {
                  tag.canLink = true;
                }
              } else {
                tag.canRollback = true;
                if (props.allowLink && !sliceLinkedToNext && currentRemovedSlice && index < props.slices.length - 1) {
                  tag.canLink = true;
                }
              }

              if (sliceLinkedToNext) {
                tag.isLinked = true;
              }

              return tag;
            })}
          />
        </div>
      )}
      {props.showPreview && props.removedSlices.length > 0 && (
        <div
          style={{
            marginTop: '-10px',
            whiteSpace: 'normal',
          }}
        >
          <small>Gap Preview</small>
          <Separator size="xs" />
          {props.slices.map((sliceText, index) => {
            if (props.removedSlices.find(removedSlice => removedSlice.index === index)) {
              return '__ ';
            }
            return `${sliceText} `;
          })}
        </div>
      )}
    </Column>
  </Row>
);

SlicesInput.propTypes = {
  slices: PropTypes.arrayOf(PropTypes.string).isRequired,
  removedSlices: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      text: PropTypes.string,
      correct: PropTypes.bool,
    })
  ).isRequired,
  onRemoveSlice: PropTypes.func.isRequired,
  onShowSlice: PropTypes.func.isRequired,
  onLinkSlice: PropTypes.func,
  errorText: PropTypes.string,
  disableRemove: PropTypes.bool.isRequired,
  sequenceRemove: PropTypes.bool.isRequired,
  allowLink: PropTypes.bool.isRequired,
  showPreview: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};

SlicesInput.defaultProps = {
  errorText: null,
  onLinkSlice: null,
  showPreview: true,
  disabled: false,
};

export default SlicesInput;
